import * as React from "react";
import type { SVGProps } from "react";
const SvgChild = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#child_svg__a)">
      <path d="M12 23a10.002 10.002 0 0 1-9.4-6.56A3.51 3.51 0 0 1 1.33 12a3.4 3.4 0 0 1 .91-1.18 10 10 0 0 1 4.08-6.06 1 1 0 0 1 1.39.25 1 1 0 0 1-.26 1.39 8.1 8.1 0 0 0-3.33 5.17.94.94 0 0 1-.44.66 1.54 1.54 0 0 0-.54.62 1.51 1.51 0 0 0 .72 2 .94.94 0 0 1 .52.6 8 8 0 0 0 5.17 5.16 8 8 0 0 0 10.07-5.16 1 1 0 0 1 .52-.6 1.5 1.5 0 0 0 .62-.55 1.47 1.47 0 0 0-.026-1.66 1.5 1.5 0 0 0-.424-.41 1 1 0 0 1-.44-.66 8 8 0 0 0-3.43-5.24 1 1 0 0 1 .748-1.81 1 1 0 0 1 .362.15 10.07 10.07 0 0 1 4.21 6.15 3.45 3.45 0 0 1 1.16 1.94 3.44 3.44 0 0 1-.48 2.63 3.5 3.5 0 0 1-1 1.05 10 10 0 0 1-4.82 5.45A9.9 9.9 0 0 1 12 23" />
      <path d="M12 19.05a4.5 4.5 0 0 1-3.22-1.35 1 1 0 1 1 1.42-1.41 2.5 2.5 0 0 0 3.53 0 1 1 0 1 1 1.44 1.39l-.07.07a4.46 4.46 0 0 1-3.1 1.3M11 9a1 1 0 0 1-1-1 6 6 0 0 0-2-4.17 1 1 0 0 1 .357-1.809 1 1 0 0 1 .753.149A7.88 7.88 0 0 1 12 8a1 1 0 0 1-1 1M14.49 9a1 1 0 0 1-1-1 7.15 7.15 0 0 0-1.8-4.4 1 1 0 0 1 1.6-1.2 9.15 9.15 0 0 1 2.2 5.6 1 1 0 0 1-1 1M10 15a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1M14 15a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1" />
    </g>
    <defs>
      <clipPath id="child_svg__a">
        <path fill="#fff" d="M1 2h22v21H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChild;
